/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {MemberInfo} from '../models/MemberInfo';

export interface GetGroupMembers$Request {
    groupId: number;
}

export interface GetGroupMembers$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getGroupMembersRequest = createAction<PayloadData<void, GetGroupMembers$Request>>('GET_GROUP_MEMBERS__GET_GROUP_MEMBERS__REQUEST');
export const getGroupMembersSuccess = createAction<PayloadData<Array<MemberInfo>, GetGroupMembers$Request>>('GET_GROUP_MEMBERS__GET_GROUP_MEMBERS__SUCCESS');
export const getGroupMembersFailure = createAction<PayloadData<Error, GetGroupMembers$Request, true>>('GET_GROUP_MEMBERS__GET_GROUP_MEMBERS__FAILURE');

export const getGroupMembersActions = [
    getGroupMembersRequest,
    getGroupMembersSuccess,
    getGroupMembersFailure
] as const;

/**
 * @param {number} meta.groupId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getGroupMembers = (meta: GetGroupMembers$Request, config?: GetGroupMembers$Config) => {
    return {
        CALL_API: {
            types: getGroupMembersActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/groups/${meta.groupId}/members`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

